import { combineReducers } from "redux";


import AuthenticationReducer from "@Reducers/Authentication";


export * from "./Authentication";


const ApplicationState = combineReducers({
    authentication: AuthenticationReducer,
});


export default ApplicationState;
